














import Vue from "vue";
import LanguageLink from "../../atoms/LanguageLink/LanguageLink.vue";
import { PropType } from "vue";
import { Option } from "@/store/models";

export default Vue.extend({
  name: "LanguageGrid",
  components: {
    LanguageLink
  },
  props: {
    options: Array as PropType<Option[]>,
    isDisabled: Boolean
  }
});
